import { render, staticRenderFns } from "./StatsBudget.vue?vue&type=template&id=5098502c"
import script from "./StatsBudget.vue?vue&type=script&lang=js"
export * from "./StatsBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports